import { render, staticRenderFns } from "./SubjectTemplateItem.vue?vue&type=template&id=ed20b010&scoped=true"
import script from "./SubjectTemplateItem.vue?vue&type=script&lang=js"
export * from "./SubjectTemplateItem.vue?vue&type=script&lang=js"
import style0 from "./SubjectTemplateItem.vue?vue&type=style&index=0&id=ed20b010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed20b010",
  null
  
)

export default component.exports